import { useEffect } from 'react'
import analytics from '@/services/analyticsService'

interface UseAnalyticsProps {
  agentSubdomain: string
  pageType?: string
  propertyId?: string
}

export const useAnalytics = ({ agentSubdomain, pageType = 'home', propertyId }: UseAnalyticsProps) => {
  useEffect(() => {
    // Inicializar analytics
    analytics.init(agentSubdomain)

    // Track página actual automáticamente SOLO si NO es property
    // Para property pages, el trackPageView se llama manualmente
    // después de obtener el UUID real de la propiedad del API
    if (pageType !== 'property') {
      analytics.trackPageView(pageType, propertyId)
    }
  }, [agentSubdomain, pageType, propertyId])

  return {
    // Exponer trackPageView para llamada manual desde property pages
    trackPageView: (realPropertyId?: string) => analytics.trackPageView(pageType, realPropertyId),
    trackChatOpen: () => analytics.trackChatEvent('chat_opened'),
    trackChatMessage: (message: string, messageCount: number) =>
      analytics.trackChatEvent('message_sent', { userMessage: message, messageCount }),
    trackDataCaptured: (data: any, score: number, temperature: string) =>
      analytics.trackChatEvent('data_captured', { dataCaptured: data, leadScore: score, leadTemperature: temperature }),
    trackChatClose: () => analytics.trackChatEvent('chat_closed'),
    trackPropertyView: (propertyId: string) => analytics.trackPropertyInteraction(propertyId, 'view'),
    trackPropertyImageClick: (propertyId: string, imageIndex: number) =>
      analytics.trackPropertyInteraction(propertyId, 'image_click', imageIndex),
    trackPropertyContact: (propertyId: string) => analytics.trackPropertyInteraction(propertyId, 'contact_click')
  }
}

export default useAnalytics
